import React from 'react';

function CartIconPlus(props) {
  return (
    <svg
      width={38}
      height={38}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.747 8.489a3.895 3.895 0 0 0-3.891 3.892v.013H11.69a.362.362 0 0 0-.361.346l-.647 14.656v.002a.362.362 0 0 0 .361.376h15.94a.36.36 0 0 0 .362-.376l-.647-14.658a.362.362 0 0 0-.361-.345h-3.485v-.014a3.895 3.895 0 0 0-3.891-3.892h-.215Zm-3.169 3.892a3.173 3.173 0 0 1 3.17-3.169h.214a3.173 3.173 0 0 1 3.169 3.17v.012h-6.553v-.013Zm-4.156 14.67.615-13.933h2.819v2.433h-.184a.362.362 0 0 0 0 .722h1.09a.362.362 0 0 0 0-.722h-.184v-2.433h6.553v2.433h-.184a.362.362 0 0 0 0 .722h1.09a.362.362 0 0 0 0-.722h-.184v-2.433h3.139l.616 13.933H11.422Z"
        fill="#474747"
      />
      <circle cx={27.346} cy={24.582} r={6.5} fill="#474747" />
      <path
        d="M27.696 24.235h2.102v.704h-2.102v2.174h-.71v-2.174h-2.092v-.704h2.093V22.05h.709v2.184Z"
        fill="#fff"
      />
    </svg>
  );
}

export default CartIconPlus;
